'use strict';
import { computeHmacSha256 } from './utils';
import { WebhookSignatureVerificationError } from './Errors';
export default class Webhooks {
    static constructEvent(payload, apiKey, apiSecret, webhookUrl) {
        Webhooks.validateWebhookEvent(payload, apiKey, apiSecret, webhookUrl);
        return JSON.parse(payload);
    }
    static constructEventWithoutVerification(payload) {
        return JSON.parse(payload);
    }
    static validateWebhookEvent(payload, apiKey, apiSecret, webhookUrl) {
        payload = Buffer.isBuffer(payload) ? payload.toString('utf8') : payload;
        const httpVerb = 'POST';
        const parsedPayload = JSON.parse(payload);
        const body = JSON.stringify(parsedPayload.data);
        if (parsedPayload.apiKey !== apiKey) {
            return false;
        }
        const rawSignature = `${parsedPayload.timestamp}\r\n${httpVerb}\r\n${webhookUrl}\r\n\r\n${body}`;
        const signature = computeHmacSha256(rawSignature, apiSecret);
        const isValidSignature = signature === parsedPayload.signature;
        if (!isValidSignature) {
            throw new WebhookSignatureVerificationError({
                message: 'No signatures found matching the expected signature for payload.' +
                    ' Are you passing the raw request body you received from Lalamove?',
            });
        }
        return true;
    }
}
//# sourceMappingURL=Webhooks.js.map